export default "__VITE_ASSET__b7bbeac6__"